<template>
  <div class="protocol login-protocol">
    <!-- <navigation>《个人信息保护政策》</navigation>
    <nd-pdf title="《个人信息保护政策》" src="https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/TMD/protocol/%E3%80%90H5%E3%80%91%E5%A4%A9%E7%BE%8E%E8%B4%B7_%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E4%BF%9D%E6%8A%A4%E6%94%BF%E7%AD%96_20221106_%E4%B8%9A%E5%8A%A1%E4%BE%A7%2BLC%20Cmts1101%E2%80%94%E2%80%94%E4%B8%9A%E5%8A%A1%E4%BE%A7%E7%A1%AE%E8%AE%A4.pdf"></nd-pdf>
    -->
  </div>

</template>

<script>

export default {
  name: 'vipProtocol',
  created () {
    const origin = process.env.VUE_APP_PROURL
    window.location.replace(`${origin}/protocol/h5/privacy`)
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .login-protocol {
        background-color: white;

        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                text-indent: 40px;
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
    }
</style>
